export default {
    // 是否存在龙腾休息室增值服务
    async queryDPRestRoomService(params) {
        let actiontype = 'ServiceCatalog_queryServiceCatalogList';
        return await this.fetch(actiontype, params);
	},
	// 是否有空余休息室
    async queryHasDPRestRoom(params) {
        let actiontype = 'dragonpassService_productCheck';
        return await this.fetch(actiontype,params);
    },
    // 休息室订单详情
    async getLoungeDetail(params) {
        let actiontype = 'dragonpassService_getMyOrderDetail'
        return await this.fetch(actiontype, params);
    },
    // 休息室订单列表
    async getLoungeList(params) {
        let actiontype = 'dragonpassService_getMyOrderList'
        return await this.fetch(actiontype, params);
    },
    // 休息室单独退单
    async refundLoungeOrder(params) {
        let actiontype = 'refundDragonpass'
        return await this.fetch(actiontype, params);
    }

}



// WEBPACK FOOTER //
// ./src/interfaces/modules/dragonpass.js